import React, {useState , useEffect} from 'react';
import logoBleu from  "../img/logo-bleu.png";
import {questions} from "./questionnaire";
import {RadioBox} from  "./radio-box";
import {QuestionEnfants} from "./questions-situation-familliale";

export default function Questions  (props) {

	const [questionId , setQuestionId] = useState (1);
	const [currentQuestion , setCurrentQuestion] = useState({...questions[ questionId]  ,...{ model : questionId }});
	const [answers , setAnswers] = useState({});
	const [valid , setValidity] = useState(false);

	//
	const handleOptionChange  = (value , model ) => {
		let newAnswer = { ...answers};
		newAnswer[model] = value;
		
		setAnswers ( newAnswer);
	};

	const getResult = ()=> {

		props.setData ({answers});
		props.nextStep();
	}

	const handleFamilyData = ( data ) => {
		let nextAnswers = {...answers};
		let dataEnfants = {};

		dataEnfants['has'] = data.hasChild;
		dataEnfants['number'] = (data.hasChild) ?  data.number : 0;

		if (data.number < 0 ){
			dataEnfants['has']  = false;
		}

		nextAnswers["enfants"] = dataEnfants;

		setAnswers(nextAnswers);
	};

	//
	const next = () => {
		
		if (!valid)
			return;

		if (answers[questionId] === 0) {
			if ( typeof answers.couple === 'undefined') {
				console.log( currentQuestion.optionals["1"]);
				setCurrentQuestion( {...currentQuestion.optionals["1"]  , ...{model: "couple"}}  );
				return;
			}

			if (typeof answers.couple !== 'undefined' && typeof answers.enfants === 'undefined' ){
				console.log(questions["1"].optionals["2"] );
				setCurrentQuestion( {...questions["1"].optionals["2"]  , ...{model: "enfants"}} );
				return;
			}

			getResult();
			return ;
		}

		if ( answers[questionId] === 0 || questionId+1 > Object.keys(questions).length) {
			getResult();
		}
		setQuestionId( questionId + 1 );
		
	};

	useEffect(() => {
		setCurrentQuestion( {...questions[ questionId]  , ...{ model : questionId }} );
	} ,  [questionId]);

	useEffect( () => {
		setValidity(typeof answers[currentQuestion.model] !== 'undefined');
	} , [currentQuestion,answers]);

	//
	return 	(
		<div className="questions" >
          <div className="question"> <p dangerouslySetInnerHTML={{__html: currentQuestion.text}}></p></div>
          <div className="choix">
          	{( currentQuestion.type === "radio" ?
          	<RadioBox
          		defaultValue={answers[currentQuestion.model]}
          		options={currentQuestion.options}
          		handler={handleOptionChange}
          		modelName={currentQuestion.model}
          	/>
  			: <QuestionEnfants handleData={handleFamilyData} />
          	)}

          </div>
          <div className="clear clearfix"></div>
          <div className={"buttonrow " + ((valid ) ? "" : "disabled")} >
          	<button id="calculate" onClick= {next}>Valider</button>
          </div>
          <div className="restart_btn" onClick ={props.restart}>Recommencer</div>
    
          <div style={{height:"40px"}}></div>
          <div className="site-address row">
              <img src={logoBleu} alt="logo aide-sociale.fr"/>
          </div>
        </div>);
}